import { useState } from "react";
import { Reclamo } from "../../../../api/apiTypes";
import { Link } from "react-router-dom";
import { routesMap } from "../../../../routes/AppRoutes";
import Paginator from '../../../../utils/Paginator';
import ReportStatusBadge from "../../../../utils/ReportStatusBadge";
import { Eye } from 'lucide-react';

type ContainerListaDriverPageProps = {
  intermediari: Reclamo[];
  driverRoute: string | undefined;
  reportId: string;
  idReport: string;
  driverId: string;
};

const ContainerReclami = ({
  reportId,
  intermediari,
  driverRoute,
  idReport,
  driverId,
}: ContainerListaDriverPageProps) => {
  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState<number>(() => {
    const saved = localStorage.getItem("reclamiPage");
    return saved ? parseInt(saved, 10) : 1; 
  });

  const totalPages = Math.ceil(intermediari.length / itemsPerPage);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    localStorage.setItem("reclamiPage", page.toString());
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = intermediari.slice(startIndex, startIndex + itemsPerPage);

  // Griglia aggiornata: tutte le colonne allineate
const gridTemplate = "grid-cols-[1.8fr_1fr_1fr_1fr_1fr_1fr_0.7fr_0.5fr_0.3fr]";
  return (
    <div className="">
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        {/* Header tabella */}
        <div className={`grid ${gridTemplate} gap-x-2 p-4 border-b border-gray-100 bg-gray-50 font-semibold text-[#1B365D] text-xs`}>
          <div className="flex items-center">Intermediari</div>
          <div className="flex items-center justify-center">Reclami totali</div> 
          <div className="flex items-center justify-center">Reclami investimento</div>
          <div className="flex items-center justify-center">Percentuali</div>
          <div className="flex items-center justify-center">Anno</div>
          <div className="flex items-center justify-center">Score</div>
          <div className="flex items-center justify-center">Stato</div>
          <div className="flex items-center justify-center">Validazione</div>
          <div />
        </div>

        {/* Body tabella */}
        {currentItems.map((intermediario) => {
          const { id, name, value, status, validation } = intermediario;

          return (
            <div
              key={id}
              className={`grid ${gridTemplate} gap-x-2 p-2 hover:bg-gray-50/50 transition duration-150 ease-in-out text-gray-800 text-xs`}
            >
              <div className="flex items-center font-medium">{name}</div>
              <div className="flex items-center justify-center font-medium">{value.total_claims}</div>
              <div className="flex items-center justify-center font-medium">{value.investment_services_claims}</div>
              <div className="flex items-center justify-center font-medium">{value.percentage_investment_claims ?? 0} %</div>
              <div className="flex items-center justify-center font-medium">{value.source_fiscal_year}</div>
              <div className="flex items-center justify-center font-medium">{value.score.total_score}</div>
              <div className="flex items-center justify-center">
                <ReportStatusBadge stato={status} />
              </div>
              <div className="flex items-center justify-center">
                <ReportStatusBadge stato={validation} />
              </div>
              <div className="flex items-center justify-center">
                <Link
                  to={routesMap.VISUALIZZA_INTERMEDIARIO(
                    reportId,
                    driverRoute ?? "",
                    intermediario.name
                  )}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium bg-[#1B365D] text-white hover:bg-[#142a4a] transition-colors"
                  state={{ idReport, driverId, key: intermediario.id }}
                >
                  <Eye className="w-3.5 h-3.5" />
                </Link>
              </div>
            </div>
          );
        })}

        {/* Paginazione */}
        {totalPages > 1 && (
          <div className="p-4">
            <Paginator
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContainerReclami;
